[
  {
    "code": "30",
    "name": "Hồ Chí Minh",
    "slug": "ho-chi-minh",
    "type": "city",
    "isCentral": true,
    "fullName": "Thành phố Hồ Chí Minh"
  },
  {
    "code": "01",
    "name": "Hà Nội",
    "slug": "ha-noi",
    "type": "city",
    "isCentral": true,
    "fullName": "Thành phố Hà Nội"
  },
  {
    "code": "02",
    "name": "Hưng Yên",
    "slug": "hung-yen",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Hưng Yên"
  },
  {
    "code": "03",
    "name": "Quảng Trị",
    "slug": "quang-tri",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Quảng Trị"
  },
  {
    "code": "04",
    "name": "Huế",
    "slug": "hue",
    "type": "city",
    "isCentral": true,
    "fullName": "Thành phố Huế"
  },
  {
    "code": "05",
    "name": "Hải Phòng",
    "slug": "hai-phong",
    "type": "city",
    "isCentral": true,
    "fullName": "Thành phố Hải Phòng"
  },
  {
    "code": "06",
    "name": "Phú Thọ",
    "slug": "phu-tho",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Phú Thọ"
  },
  {
    "code": "07",
    "name": "Thanh Hoá",
    "slug": "thanh-hoa",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Thanh Hoá"
  },
  {
    "code": "08",
    "name": "Quảng Ninh",
    "slug": "quang-ninh",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Quảng Ninh"
  },
  {
    "code": "09",
    "name": "Lào Cai",
    "slug": "lao-cai",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Lào Cai"
  },
  {
    "code": "10",
    "name": "Bắc Ninh",
    "slug": "bac-ninh",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Bắc Ninh"
  },
  {
    "code": "11",
    "name": "Nghệ An",
    "slug": "nghe-an",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Nghệ An"
  },
  {
    "code": "12",
    "name": "Đà Nẵng",
    "slug": "da-nang",
    "type": "city",
    "isCentral": true,
    "fullName": "Thành phố Đà Nẵng"
  },
  {
    "code": "13",
    "name": "Ninh Bình",
    "slug": "ninh-binh",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Ninh Bình"
  },
  {
    "code": "14",
    "name": "Khánh Hòa",
    "slug": "khanh-hoa",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Khánh Hòa"
  },
  {
    "code": "15",
    "name": "Tây Ninh",
    "slug": "tay-ninh",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Tây Ninh"
  },
  {
    "code": "16",
    "name": "Đồng Tháp",
    "slug": "dong-thap",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Đồng Tháp"
  },
  {
    "code": "17",
    "name": "Hà Tĩnh",
    "slug": "ha-tinh",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Hà Tĩnh"
  },
  {
    "code": "18",
    "name": "An Giang",
    "slug": "an-giang",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh An Giang"
  },
  {
    "code": "19",
    "name": "Thái Nguyên",
    "slug": "thai-nguyen",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Thái Nguyên"
  },
  {
    "code": "20",
    "name": "Lạng Sơn",
    "slug": "lang-son",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Lạng Sơn"
  },
  {
    "code": "21",
    "name": "Điện Biên",
    "slug": "dien-bien",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Điện Biên"
  },
  {
    "code": "22",
    "name": "Đồng Nai",
    "slug": "dong-nai",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Đồng Nai"
  },
  {
    "code": "23",
    "name": "Quảng Ngãi",
    "slug": "quang-ngai",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Quảng Ngãi"
  },
  {
    "code": "24",
    "name": "Vĩnh Long",
    "slug": "vinh-long",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Vĩnh Long"
  },
  {
    "code": "25",
    "name": "Cao Bằng",
    "slug": "cao-bang",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Cao Bằng"
  },
  {
    "code": "26",
    "name": "Lai Châu",
    "slug": "lai-chau",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Lai Châu"
  },
  {
    "code": "27",
    "name": "Đắk Lắk",
    "slug": "dak-lak",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Đắk Lắk"
  },
  {
    "code": "28",
    "name": "Gia Lai",
    "slug": "gia-lai",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Gia Lai"
  },
  {
    "code": "29",
    "name": "Lâm Đồng",
    "slug": "lam-dong",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Lâm Đồng"
  },
  {
    "code": "31",
    "name": "Sơn La",
    "slug": "son-la",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Sơn La"
  },
  {
    "code": "32",
    "name": "Cần Thơ",
    "slug": "can-tho",
    "type": "city",
    "isCentral": true,
    "fullName": "Thành phố Cần Thơ"
  },
  {
    "code": "33",
    "name": "Cà Mau",
    "slug": "ca-mau",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Cà Mau"
  },
  {
    "code": "34",
    "name": "Tuyên Quang",
    "slug": "tuyen-quang",
    "type": "province",
    "isCentral": false,
    "fullName": "Tỉnh Tuyên Quang"
  }
]
